import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
const Faq = () => {
    const [faqs, setFaqs] = useState([]);
    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_FAQS;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setFaqs(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, []);

    return (
        <main>
            <section className="contact-banner-area" id="contact">
                <div className="container h-100">
                    <div className="contact-banner">
                        <div className="text-center">
                            <h1>FAQ'S</h1>
                            <nav aria-label="breadcrumb" className="banner-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">FAQ'S</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <section className="blog-area pt-5">
                <div className="container h-100">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-10 col-12">
                            <div className="blog_left_sidebar">
                                <div className="accordion" id="accordionExample">
                                    {faqs.map((faq,index) => {
                                        const headingId = `heading${index}`;
                                        const collapseId = `collapse${index}`;
                                        const isFirst = index === 0;
                                        return (
                                            <div className="accordion-item" key={index}>
                                                <h2 className="accordion-header" id={headingId}>
                                                    <button className={`accordion-button ${!isFirst ? 'collapsed' : ''}`} type="button" data-bs-toggle="collapse"
                                                            data-bs-target={`#${collapseId}`} aria-expanded="false" aria-controls={collapseId}>
                                                        {faq?.qn}
                                                    </button>
                                                </h2>
                                                <div id={collapseId} className={`accordion-collapse collapse ${isFirst ? 'show': ''}`}
                                                     aria-labelledby={headingId}
                                                     data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        {faq?.answer}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </main>
    );
}
export default Faq;